var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPartnerAp = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 19 18",
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M11.4951 0L18.793 12.7383L16.5166 17.2754H11.4951L9.42383 13.2041H14.7744L14.3711 12.4648L9.78613 4.05371L9.35938 3.27148L8.91406 4.04297L6.65723 7.9502L4.69824 4.24609L6.91016 0L11.4951 0ZM6.36914 8.44922L6.50098 8.69434L8.66895 12.7383H4.69824L2.38965 17.0332L0 12.7383L2.38965 8.42773H6.38184L6.36914 8.44922Z",
  fill: "white",
  fillOpacity: 0.6
})));
export default SvgPartnerAp;